import React from "react";

function Header(props) {
  return (
    <div
      className="header"
      style={{
        position: "absolute",
        right: "0px",
        top: "10px",
        width: "max-content",
      }}
    >
      <nav className="navbar pt-t">
        <div className="container-xxl mobileHeaderShow">
          <div className="h-right d-flex align-items-center order-1">
          </div>
          <button
            className="navbar-toggler p-0 border-0 menu-toggle order-3"
            type="button"
            onClick={() => {
              let sidebar = document.getElementById("mainsidemenu");
              if (sidebar) {
                if (sidebar.classList.contains("open")) {
                  sidebar.classList.remove("open");
                } else {
                  sidebar.classList.add("open");
                }
              }
            }}
          >
            <span className="fa fa-bars"></span>
          </button>
        </div>
      </nav>
    </div>
  );
}

export default Header;
